import React from "react";
import PropTypes from "prop-types";
import FixedNavbar from "./FixedNavbar";
import logo from "../../images/ATS-Logo-Light.png";

export default class NavbarContainer extends React.Component {
  static propTypes = {
    fixed: PropTypes.bool
  };

  static defaultProps = {
    fixed: false
  };

  static _meta = {
    name: "Navbar"
  };

  state = {
    isOpen: false
  };

  toggleMenu = () => {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen });
  };

  closeMenu = () => {
    this.setState({ isOpen: false });
  };

  render() {
    const { isOpen } = this.state;
    const { fixed } = this.props;

    return (
      <FixedNavbar
        onIconClick={this.toggleMenu}
        onNavLinkClick={this.closeMenu}
        onClick={this.closeMenu}
        active={isOpen}
        fixed={fixed}
        links={navbarItems}
        logo={logo}
      />
    );
  }
}

// ----------------------------------------
// Pages linked in Navbar
// ----------------------------------------

const navbarItems = [
  {
    type: "link",
    title: "Home",
    path: "/",
    exact: true
  },
  {
    type: "link",
    title: "Showcase",
    path: "/showcase"
  },
  {
    type: "dropdown",
    title: "Services",
    contents: [
      { type: "link", title: "CNC Machining", path: "/cnc" },
      { type: "link", title: "Glass Sealing", path: "/glass-seals" },
      { type: "link", title: "Our Workflow", path: "/workflow" }
    ]
  },
  {
    type: "dropdown",
    title: "Our Shop",
    contents: [
      { type: "link", title: "Equipment List", path: "/equipment" },
      { type: "link", title: "Materials", path: "/materials" }
    ]
  },
  {
    type: "link",
    title: "About",
    path: "/about"
  },
  {
    type: "link",
    title: "Contact Us",
    path: "/contact",
    isButton: true
  }
];



// WEBPACK FOOTER //
// ./src/components/Navbar/NavbarContainer.js